var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.411,
    height: 46.411,
    viewBox: "0 0 46.411 46.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M28.206,5A23.206,23.206,0,1,0,51.411,28.206,23.206,23.206,0,0,0,28.206,5Z",
    transform: "translate(-5 -5)",
    fill: "#039be5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M28.811,32.63h6.005l.943-6.1H28.81V23.195c0-2.534.828-4.782,3.2-4.782h3.809V13.089a32.359,32.359,0,0,0-4.76-.288c-5.585,0-8.86,2.95-8.86,9.669v4.059H16.457v6.1H22.2V49.4a23.253,23.253,0,0,0,3.471.287,23.357,23.357,0,0,0,3.141-.237Z",
    transform: "translate(-2.464 -3.273)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.19186ecc3a86a7c0b54f7fe67fd5a98f.svg";
export { ForwardRef as ReactComponent };